import React, { useState } from 'react'
import { Tooltip } from 'antd'
import { IconInfo } from '@edulastic/icons'
import InputTag from './SearchTag'
import { SearchWrapper } from '../Container/styled'
import { useGetAutoCompleteDict } from '../../../src/selectors/autoComplete'

/**
 * Reusable search input component with tooltip
 * Used across ItemList and AddItems components for consistent search UI
 */
const SearchInputWithTooltip = ({
  placeholder = 'Search by question phrase or topic. Use the left filters to narrow by Standard, Tags, etc.',
  tooltipTitle = 'Enter a phrase or topic to find questions. Use the left filters to narrow your search by Standard (e.g., 8.EE.A.1). To find questions by specific tests or keywords (e.g., LEAP, photosynthesis), use the Tags filter.',
  onSearchInputChange,
  value = [],
  disabled = false,
}) => {
  const [suggestions, setSuggestions] = useState([])
  const [suggestionKeyWord, setSuggestionKeyWord] = useState([])
  const dict = useGetAutoCompleteDict()

  const computeSuggestions = (e) => {
    const target = e.target
    const textValues = (target.value || '').split(' ')
    const textValue = textValues[textValues.length - 1].toLowerCase()
    let allPossibleValues = []
    if (target.value.length >= 3 && textValue.length) {
      allPossibleValues = dict.filter(
        (str) => str.startsWith(textValue) && str != textValue
      )
    }
    allPossibleValues.splice(5)
    setSuggestionKeyWord(target.value)
    setSuggestions(
      allPossibleValues.map(
        (word) => target.value + word.slice(textValue?.length || 0)
      )
    )
  }

  return (
    <SearchWrapper>
      <InputTag
        placeholder={placeholder}
        onSearchInputChange={onSearchInputChange}
        value={value}
        disabled={disabled}
        computeSuggestions={computeSuggestions}
        suggestions={suggestions}
        suggestionKeyWord={suggestionKeyWord}
        library="item"
      />
      <Tooltip title={tooltipTitle} placement="left">
        <IconInfo width={20} height={20} style={{ marginLeft: '10px' }} />
      </Tooltip>
    </SearchWrapper>
  )
}

export default SearchInputWithTooltip
